import { createAsyncThunk } from '@reduxjs/toolkit'
import { ErrorStore, ListPaymentLinksResponse } from '@types'
import {
  STORE_PAYMENT,
  STORE_PAYMENT_LIST_PAYMENT_LINKS,
  STORE_STATUS_INITIALIZED,
  STORE_STATUS_LOADING,
} from 'constants/store'
import { Payload } from 'stores'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'

type ListPaymentLinksState = {
  list: ListPaymentLinksResponse
  shouldRefetch: boolean
}

type State = GenericState<ListPaymentLinksState>

export const initialState: State = {
  data: {
    shouldRefetch: false,
    list: {
      total: 0,
      payment_links: [],
    },
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchListPaymentLinks = createAsyncThunk<
  ListPaymentLinksState,
  Promise<ListPaymentLinksResponse>,
  Payload
>(
  STORE_PAYMENT_LIST_PAYMENT_LINKS,
  async (promise: Promise<ListPaymentLinksResponse>, { rejectWithValue }) => {
    try {
      const response = await promise

      return {
        list: response,
        shouldRefetch: false,
      }
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  ListPaymentLinksState,
  ListPaymentLinksResponse,
  Payload
>(fetchListPaymentLinks, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_PAYMENT,
  initialState,
  reducers: {
    refetch: (state) => {
      return {
        ...state,
        data: {
          list: state.data.list,
          shouldRefetch: true,
        },
        status: STORE_STATUS_LOADING,
      }
    },
  },
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, refetch } = actions

export { clear, refetch }

export default reducer
